export default {
  messages: [],
  loading: false,
  isDialog: false,
  chatInstanceId: null,
};
